<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="navigation-container" v-if="$auth.ready() && $auth.check()">
    <v-navigation-drawer light fixed disable-resize-watcher disable-route-watcher
                         :clipped="$vuetify.breakpoint.width > 1264"
                         v-model="drawer" app>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon>person</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{$auth.user().firstName}} {{$auth.user().lastName}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon small to="/user/profile">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-list dense>
        <v-list-item to="/">
          <v-list-item-action>
            <v-icon>dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("menu.dashboard") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_ADMIN')" dense>
        <v-divider/>
        <v-subheader>
          {{ $t("menu.employees") }}
        </v-subheader>
        <v-list-item to="/user/manage">
          <v-list-item-action>
            <v-icon>supervisor_account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("menu.manage") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_ADMIN') || $auth.check('ROLE_MODERATOR')" dense>
        <v-divider/>
        <v-subheader>
          {{ $t("menu.event") }}
        </v-subheader>
        <v-list-item to="/event/manage">
          <v-list-item-action>
            <v-icon>event</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("menu.manage") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_ADMIN') || $auth.check('ROLE_MODERATOR')" dense>
        <v-divider/>
        <v-subheader>
          <v-badge color="red" v-model="hasUnread">
            <template v-slot:badge>!</template>
            {{ $t("menu.messages") }}
          </v-badge>
        </v-subheader>
        <v-list-item to="/message/manage">
          <v-list-item-action>
            <v-icon>message</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("menu.manage") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_ADMIN') || $auth.check('ROLE_MODERATOR')" dense>
        <v-divider/>
        <v-subheader>
          {{ $t("menu.hotel") }}
        </v-subheader>
        <v-list-item to="/hotel/create">
          <v-list-item-action>
            <v-icon>business</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("menu.create") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/hotel/manage">
          <v-list-item-action>
            <v-icon>business</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("menu.edit") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/hotel/minimum/stay">
          <v-list-item-action>
            <v-icon>today</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Mindestaufenthalt
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/hotel/dynamic">
          <v-list-item-action>
            <v-icon>today</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Ratenkalender
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_ADMIN') || $auth.check('ROLE_MODERATOR')" dense>
        <v-divider/>
        <v-subheader>
          Preisberechnung
        </v-subheader>
        <v-list-item to="/report">
          <v-list-item-action>
            <v-icon>report</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Meldungen
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_MANAGER') || $auth.check('ROLE_USER')" dense>
        <v-list-item to="/rate/calendar">
          <v-list-item-action>
            <v-icon>today</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Ratenkalender
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_MANAGER') || $auth.check('ROLE_USER')" dense>
        <v-list-item to="/rate/calculator">
          <v-list-item-action>
            <v-icon>date_range</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Preisberechnung
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_MANAGER') || $auth.check('ROLE_USER')" dense>
        <v-list-item to="/protocol">
          <v-list-item-action>
            <v-icon>list_alt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Protokolle
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="$auth.check('ROLE_MANAGER')" dense>
        <v-list-item to="/staff">
          <v-list-item-action>
            <v-icon>group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Mitarbeiter
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense>
        <!--<v-list-tile v-if="$auth.check('ROLE_USER')" to="/profile">
          <v-list-tile-action>
            <v-icon>security</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Meine Daten
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->
        <v-divider/>
        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>power_settings_new</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("menu.logout") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar dense fixed clipped-left app light>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon medium>dehaze</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <img src="../../assets/logo.png" alt="Toursol">
      </v-toolbar-title>
      <v-spacer/>
      <v-btn outlined @click="goContact()"
             v-if="$vuetify.breakpoint.mdAndUp"
             :class="[{'selected': isContact}]">{{ $t("menu.contact") }}</v-btn>
      <v-btn outlined @click="logout()"
             v-if="$vuetify.breakpoint.mdAndUp">
        <v-icon left>power_settings_new</v-icon>{{ $t("menu.logout") }}</v-btn>
    </v-app-bar>
  </div>
</template>

<script>
  export default {
    data: () => ({
      drawer: null,
      hasUnread: false,
      interval: undefined
    }),
    mounted() {
      if (this.$auth.ready() && (this.$auth.check('ROLE_ADMIN')
          || this.$auth.check('ROLE_MODERATOR'))) {
        this.fetchData();
        this.interval = setInterval(
          () => this.fetchData()
          , 120000); // every two minute once
      }
    },
    watch:{
      $route (to, from){
        if (to.name !== from.name) {
          this.closeMenu();
        }
      }
    },
    methods: {
      closeMenu() {
        if (this.drawer) {
          this.drawer = !this.drawer;
        }
      },
      goHome() {
        this.closeMenu();
        this.$router.push({name: 'Home'});
      },
      goAbout() {
        this.closeMenu();
        this.$router.push({name: 'About'});
      },
      goContact() {
        this.closeMenu();
        this.$router.push({name: 'Contact'});
      },
      logout() {
        this.$store.dispatch('resetStatistics');
        this.$store.dispatch('resetHotel');
        this.$store.dispatch('resetMinStay');
        this.$auth.logout({
          redirect: '/login',
        });
      },
      fetchData() {
        this.$http.get('message/unread')
          .then((data) => {
            this.hasUnread = data.body;
          });
      }
    },
    computed: {
      isHome() {
        return this.$route.name === 'Home';
      },
      isAbout() {
        return this.$route.name === 'About';
      },
      isContact() {
        return this.$route.name === 'Contact';
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/layout";
  @import "../../assets/scss/variables";
  @import "../../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css";

  .navigation-container {
    .v-navigation-drawer {
      .v-list {
        padding: 0;
      }
      .v-list-item__content {
        text-align: left;
      }
      .v-subheader {
        font-size: 13px;
        height: 25px;
        color: $primary-text;
      }
      .v-badge__badge {
        top: -5px !important;
        right: -5px !important;
        height: 22px !important;
        width: 6px !important;
      }
    }

    .v-toolbar {
      background: white;
      // color: white !important;
      box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0px rgba(0,0,0,0.14), 0 1px 10px 0px rgba(0,0,0,0.12);;

      .v-app-bar__nav-icon {
        margin-left: 10px;
        .v-btn__content {
          i {
            color: black !important;
          }
        }
        &:hover {
          color: transparent !important;
        }
        &:focus {
          color: transparent !important;
        }
      }

      img {
        height: 20px !important;
      }

      .v-toolbar__content {
        .v-icon {
          cursor: pointer;
          color: $primary-text !important;
          &:hover {
            color: $primary;
          }
        }
        .v-btn {
          margin-right: 15px;
          height: 36px !important;
          color: $primary-text;

          &.selected {
            color: $primary-light;
          }

          &:hover {
            color: $primary-light;
          }
        }
        .v-btn--active {
          color: $primary-light;
        }
      }
    }
  }
</style>
